import { DocumentStatus, TemplateDocumentType } from "../document/document-template-model";
import { BaseSearchModel } from "../query/base-search.model";

export class MyfileSearchModel extends BaseSearchModel {
    sourceId?: string = "";
    status?: DocumentStatus;
    types?: TemplateDocumentType[];

    constructor(
        sourceId?: string,
        searchTerm?: string,
        status?: DocumentStatus,
        types?: TemplateDocumentType,
        pageSize?: number) {
        super();
        this.pageIndex = undefined;
        this.sourceId = sourceId;
        this.searchTerm = searchTerm;
        this.status = status;
        if (types) {
            this.types = [types];
        }
        if (pageSize) {
            this.pageSize = pageSize;
        } else {
            this.pageSize = undefined;
        }
    }
}
